export default {
    endpoint: `${"https://" + window.location.host + "/api/"}`  
};